import { defaultQueryOptions } from 'constants/'
import { useUserService } from 'hooks/services/useUserService'
import { User } from 'hooks/services/useUserService/types'
import { useQuery } from 'react-query'
import { logFactory } from 'utils'

interface UseHookContext {
  data?: User
  isError: boolean
  isLoading: boolean
}

const hookName = 'useCurrentUser'
const log = logFactory(hookName)

const useCurrentUser = (): UseHookContext => {
  const { getCurrentUser } = useUserService()

  const doQuery = async () => {
    log(`👤 Getting current user...`)

    const currentUser = await getCurrentUser()

    log(`👤 Found current user`, currentUser)

    return currentUser
  }

  return useQuery([hookName], doQuery, defaultQueryOptions)
}

export { useCurrentUser }
